import React, {useEffect, useState} from "react";
import { Modal } from 'react-bootstrap';
import styled from 'styled-components'

const StyledBody = styled(Modal.Body)`
    padding:5px 0 0 0;
  `;
const StyledHeader = styled(Modal.Header)`
  border-bottom:none;
  padding-top:1.2rem;
`;



function Toast( { msg } ){ 

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  useEffect(()=>{
    if(msg){
      setShow(true);
    }
  },[msg])  
  
  return (
      <>
      <Modal show={show} onHide={handleClose}>
        <StyledHeader closeButton>{msg}</StyledHeader>
        <StyledBody></StyledBody>         
      </Modal>
    </>
  )
}
export default Toast;